<template>
  <div class="auth">
    <div class="logo"></div>
    <div class="line"></div>
    <div class="title">
      <div>请确认以下授权信息</div>
      <div>· 获取你的公开信息（呢称、头像等）</div>
    </div>
    <van-button type="primary" @click="login" class="btn">确认授权</van-button>
  </div>
</template>

<script>
// const code = window.location.search.split("=")[1].split("&")[0];
// window.localStorage.setItem("code", code);
export default {
  name: "auth",

  data() {
    return {};
  },
  created() {
    window.localStorage.setItem(
      "code",
      window.location.search.split("=")[1].split("&")[0]
    );
    // const code = window.location.search.split("=")[1].split("&")[0];
  },
  mounted() {},

  methods: {
    login() {
      this.$router.replace("/login");
    },
  },
};
</script>

<style lang="less" scoped>
.auth {
  padding: 0 40px;
  .logo {
    width: 134px;
    height: 268px;
    background: url("../../assets/loginLogo.png") no-repeat;
    background-size: cover;
    margin: 0 auto;
    margin-top: 88px;
  }
  .line {
    width: 100%;
    height: 1px;
    background: rgba(237, 237, 237, 1);
    margin-top: 40px;
  }
}
.btn {
  border-radius: 16px;
  margin-top: 88px;
  height: 100px;
  font-size: 28px !important;
}
::v-deep .van-button {
  width: 100%;
  // height: 58px;
}
.title {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 520px;
  height: 114px;

  margin: 0 auto;
  margin-top: 50px;
  div:nth-child(1) {
    margin: 0 auto;
    color: rgba(51, 51, 51, 1);
    font-size: 36px;
    font-weight: bold;
  }
  div:nth-child(2) {
    margin: 0 auto;
    color: rgba(51, 51, 51, 1);
    font-size: 28px;
    font-weight: bold;
  }
}
</style>
